import React from 'react';
import { useNavigate } from 'react-router-dom';
import SubscriptionForm from './SubscriptionForm.js';
import SubscriptionFormWrapper from './SubscriptionFormWrapper.js';

const AddSubscription = () => {
  const subscription = {
    articles: [],
    author: {},
    subscriptionPlans: [
      { type: 'Yearly', price: 0 },
      { type: 'Monthly', price: 0 }
    ],
    tags: [],
    tagsCache: [],
    images: {}
  };

  // navigating back to the previous page
  const navigate = useNavigate();

  const handleSave = (upsertedSubscripton) => {
    navigate(`/admin/subscriptions/${upsertedSubscripton.id}/${upsertedSubscripton.title}`);
  };

  return (
    <SubscriptionFormWrapper>
      {({ authors, prices, tags, publishers }) => (
        <SubscriptionForm
          subscription={subscription}
          authors={authors}
          prices={prices}
          tags={tags}
          publishers={publishers}
          onSave={handleSave}
        />
      )}
    </SubscriptionFormWrapper>
  );
};

export default AddSubscription;
